<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" :size="size">
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.audioName"
        placeholder="音频（集）名称"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" :title="'查询'" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
import { getDataMap } from "@/api/sysParam";

export default {
  components: {
    butn,
  },
  data() {
    return {
      filters: {},
      onlineList: [],
      topList: [],
      audioCategoryData: [],
      sharedData: [],
      size: "small",
    };
  },
  created() {
    this.getSysParam("IS_VALID");
  },
  methods: {
    // 获取数据字典
    getSysParam(param) {
      getDataMap(param).then((res) => {
        if (!res || res.code != 0) return;
        res.data.splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        if (param == "IS_VALID") {
          this.topList = res.data;
        }
      });
    },

    initData() {
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
    resetData() {
      this.filters = {};
      this.$emit("search", { t: new Date().getTime() });
    },
  },
};
</script>
